<script setup lang="ts">
</script>

<template>
  <footer class="app-footer">
    <div class="footer-left">
      <span class="shortcut-hints">
        <kbd>Ctrl+S</kbd> Save
        <kbd>Ctrl+I</kbd> Import
        <kbd>Ctrl+E</kbd> Export
        <kbd>Ctrl+N</kbd> New
      </span>
    </div>
    <div class="footer-center">
      <span>EveFit &copy; 2026 &mdash; Fly safe o7</span>
    </div>
    <div class="footer-right">
      <a
        href="https://paypal.me/eutopic?country.x=US&locale.x=en_US"
        target="_blank"
        rel="noopener noreferrer"
        class="donate-link"
        title="Support the project"
      >
        Support the project
      </a>
    </div>
  </footer>
</template>

<style scoped>
.app-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 34px;
  padding: 6px 16px;
  background: linear-gradient(180deg, var(--bg-darker), #05070b);
  border-top: 1px solid var(--border-color);
  color: var(--text-muted);
  font-family: var(--font-mono);
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  flex-shrink: 0;
}

.footer-left,
.footer-center,
.footer-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.shortcut-hints {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

kbd {
  display: inline-flex;
  align-items: center;
  min-height: 18px;
  padding: 1px 5px;
  border: 1px solid var(--border-bright);
  border-bottom-color: var(--border-accent);
  border-radius: var(--radius-sm);
  background: var(--bg-input);
  color: var(--accent-blue);
  font-family: var(--font-mono);
  font-size: 0.62rem;
  box-shadow: inset 0 -1px 0 rgba(0, 212, 255, 0.1);
}

.donate-link {
  color: var(--text-secondary);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.donate-link:hover {
  color: var(--accent-blue);
}

@media (max-width: 760px) {
  .app-footer {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
